module.exports = __webpack_public_path__ + "img/pwd.ce4e3597.svg";